let CryptoJS = window.CryptoJS;

export const KEY = CryptoJS.enc.Utf8.parse("_aes_futong_key_");
export const IV = CryptoJS.enc.Utf8.parse('_aes_futong_iv__');
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export const encryptBy = (word, keyStr, ivStr) => {
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function decryptBy (word, keyStr, ivStr) {
  let key = KEY;
  let iv = IV;

  let result = word;

  try {
    if (keyStr) {
      key = CryptoJS.enc.Utf8.parse(keyStr);
      iv = CryptoJS.enc.Utf8.parse(ivStr);
    }
    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    let decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });

    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    result = decryptedStr.toString();
  } catch (e) {
    // console.error("非加密字符串，无法转换：", e);
  }

  return result;
}

/**
 * 信息脱敏
 * @param str 要脱敏的字符串
 * @param start 从第几个开始显示星号，不传默认为1
 * @param end 从后面数到第几个结束显示星号，不传默认为到最后
 */
export const desensitization = (str, start, end) => {
  if (!str) {
    return;
  }
  if (start && isNaN(start)) {
    throw new Error("开始位置必须是数字");
  }
  if (end && isNaN(end)) {
    throw new Error("结束位置必须是数字")
  }
  let s = Number(start) || 1;
  let e = Number(end) || 0;
  if (str.length < s + e) {
    return str;
  }
  return str.slice(0, s) + repeatString("*", str.length - (s + e)) + str.slice(e ? (0 - e) : str.length);
}

// 定义一个辅助函数，用于重复一个字符串n次
function repeatString(str, n) {
  // 定义一个变量，存储重复后的字符串
  let repeated = "";
  // 使用一个循环，重复n次
  for (let i = 0; i < n; i++) {
    // 每次循环，将str添加到repeated后面
    repeated += str;
  }
  // 返回重复后的字符串
  return repeated;
}
